import { API, Auth } from 'aws-amplify';
// import { errorHandler } from './../errorHandle';


const getBlob = async (img) => {
  const resp = await fetch(img);
  const imageBody = await resp.blob();
  return imageBody;
};

const UploadPhoto = async (img, folder, fileName, fileType, studentId) => {
  let status = 0;
  const imageBody = await getBlob(img);

  const myKey = `${folder}/${studentId}/${fileName}`;
  const myInit = {
    body: { key: myKey },
  };
  const data = await API.post('TIR', '/v3/student/url/upload', myInit);
  await fetch(data.presigned_url, {
    method: 'PUT',
    headers: {
      'Content-Type': '',
    },
    body: imageBody,
  }).then((result) => {
      try{
        status = result.status;
      }
      catch{
        status = 500;
        result.text().then(text => {
          // errorHandler(studentId, text)
        })
      }
    })
    .catch((error) => {
      status = 500;
      error.text().then(error => {
        // errorHandler(studentId, error)
      })
    });
  return status;
};


export { UploadPhoto };
